import type { ButtonProps } from '@ariakit/react';
import { Button as AriakitButton } from '@ariakit/react';
import clsx from 'clsx';

import { Text } from '../Text/Text';

import * as styles from './styles.css';

type Props = React.PropsWithChildren & ButtonProps & styles.Variants;

export const ButtonLink: React.FC<Props> = ({ children, kind, 'aria-label': ariaLabel, ...buttonProps }) => (
  <AriakitButton
    render={<button aria-label={ariaLabel} />}
    className={clsx(styles.button, styles.variants({ kind }))}
    type="button"
    aria-label={ariaLabel}
    {...buttonProps}
  >
    <Text>{children}</Text>
  </AriakitButton>
);
